import * as ScreenSizes from './ScreenSizes';

export const MAIN_SECTION_MAX_WIDTH = 1280;
export const MAIN_SECTION_PADDING_X = 48;
export const MAIN_SECTION_PADDING_Y = 40;

export const SCREEN_SIZE_ORDER = [
  ScreenSizes.XS,
  ScreenSizes.SM,
  ScreenSizes.MD,
  ScreenSizes.LG,
  ScreenSizes.XL,
];

export const GRID_BREAKPOINT_SMALL = '544px' as const;
export const GRID_BREAKPOINT_SMALL_INT = 544 as const;

export const GRID_BREAKPOINT_MEDIUM = '768px' as const;
export const GRID_BREAKPOINT_MEDIUM_INT = 768 as const;

export const GRID_BREAKPOINT_LARGE = '992px' as const;
export const GRID_BREAKPOINT_LARGE_INT = 992 as const;

export const GRID_BREAKPOINT_EXTRA_LARGE = '1200px' as const;
export const GRID_BREAKPOINT_EXTRA_LARGE_INT = 1200 as const;
